/**
 * Puente entre @minetrace/ui y el tema de la app.
 *
 * El shell de la web expone el mineral de la sección actual como variables CSS
 * (`--k-accent`, `--k-accent-deep`, `--k-accent-soft`). Los componentes del
 * paquete las leen con un respaldo verde, así heredan el color del módulo sin
 * recibirlo por props y siguen funcionando fuera de la web.
 */
export const ACCENT = 'var(--k-accent, #cf6a35)'
export const ACCENT_DEEP = 'var(--k-accent-deep, #b4532a)'
export const ACCENT_SOFT = 'var(--k-accent-soft, #f9e6da)'

export const FONT_DISPLAY = "'Bricolage Grotesque', 'Instrument Sans', sans-serif"
export const FONT_MONO = "'JetBrains Mono', ui-monospace, monospace"

export const INK = '#2a2622'
export const INK_MUTED = '#857b71'
export const LINE = '#e6e2db'
export const SUNK = '#f3f1ed'
export const SURFACE_ALT = '#faf9f7'
/** Botón primario: terracota de marca (antes verde #1b4332). */
export const PRIMARY = '#b4532a'
export const DANGER = '#c8442f'

export const SHADOW_MD = '0 12px 30px -16px rgba(74, 52, 30, 0.28), 0 1px 2px rgba(74, 52, 30, 0.06)'
export const SHADOW_LG = '0 26px 50px -18px rgba(60, 40, 22, 0.35), 0 4px 12px rgba(60, 40, 22, 0.08)'

export const EASE_OUT: [number, number, number, number] = [0.2, 0.7, 0.2, 1]
